// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { TILES_VIEW_TYPE, } from "./index"
import { TilesViewType } from "../action-pane/tiles/tiles"

export type StorageWriter = (value: TilesViewType) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(TILES_VIEW_TYPE, value.toString())
}

export const persistTilesViewType = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setTilesViewType.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.tilesViewTypePersisted()),
        catchError(_ => of(Actions.tilesViewTypePersistFailed())),
      )),
    )

export default persistTilesViewType(persist)
